import React from 'react';
import { useNavigate } from 'react-router-dom';

function ComponentsPage() {
    const navigate = useNavigate();

    const handleCategoryClick = (category) => {
        navigate(`/${category}`);
    };

    return (
        <div>
            <h1>Components</h1>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
                <button 
                    
                    onClick={() => handleCategoryClick('labour')}
                >
                    Labour
                </button>
                <button 
                    
                    onClick={() => handleCategoryClick('materials')}
                >
                    Materials
                </button>
                <button 
                    
                    onClick={() => handleCategoryClick('plant')}
                >
                    Plant
                </button>
            </div>
        </div>
    );
}

export default ComponentsPage;
